import 'consumerweb-shim';
import React from 'react'
import $ from 'jquery'
import { Router, Route, browserHistory } from 'react-router'
import { render } from 'react-dom'

import CookiedUserPage from './landing/landing'
import GuestPage from './guest/guest'
import CrossBorder from './guest/crossBorder'
import GuestConfirmation from './guest/confirmation'
import GuestPending from './guest/pending'
import templateData from './utility/getTemplateData'

const currentState = templateData.currentState
const currentUserState = templateData.currentUserState
const LandingPage = React.createClass({

	contextTypes: {
		router: React.PropTypes.object.isRequired
	},

	getInitialState: function() {

		return {
			userCookied: currentUserState === 'cookied'
		}
	},

	componentDidMount() {

		if (currentState) {
			this.context.router.push(currentState)
		}
		$('.spinneroverlay').hide();
	},

	render() {
		return (
			<div>{this.state.userCookied ? <CookiedUserPage/> : <GuestPage />}</div>
		)
	}
})

render((
	<Router history={browserHistory}>
		<Route path="/donate" component={LandingPage} />
		<Route path="/donate/guest" component={GuestPage} />
		<Route path="/donate/guest/crossborder" component={CrossBorder} />
		<Route path="/donate/guest/confirmation" component={GuestConfirmation} />
		<Route path="/donate/guest/pending" component={GuestPending} />
	</Router>
), document.getElementById('donateWrapper'))



// WEBPACK FOOTER //
// ./router.js